import React from 'react';
import { Container, Header, Divider } from 'semantic-ui-react';


class SciencePark extends React.Component{
  render(){
    return <Container text textAlign='left'>
      <Header as='h3' textAlign='center'>
    Hong Kong Science Park
    </Header>
    <Divider/>

    <p>Located in Shatin, Hong Kong, the Science Park campus provides a serene
countryside setting for science and innovation companies. The campus is adjacent
to the Chinese University of Hong Kong and its School of Medicine. Designated as a
national lab by China, the Science Park enjoys special research protocol with its
science counterparts in China.</p>
    <p>Hong Kong Government offers financial support and research grant programs
(Enterprise Support Schemes) to attract science and technology companies to be
situated in the Science Park.</p>
  <p>OVC works closely with the local universities in Hong Kong and the Science
  Park and identifies prominent principal investigators for science and clinical
  trial collaborations for the portfolio companies.  By maintaining physical
  presence in the Science Park, portfolio companies can utilize the financial and
  business support schemes offered by various science and innovation programs funded
  by the Hong Kong Government.</p>
    </Container>;
  }
}

export default SciencePark;
